import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { ImageCornSchema, InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { PartialMediaMetadataSchema } from '../base/mediaMetadata.js';
import { ImageSchema } from '../entities/image.js';
export const UpdateImageBodySchema = z.object({
    description: z.string().optional(),
    labels: z.array(z.string()).optional(),
    metadata: PartialMediaMetadataSchema.optional(),
    order: z.number().optional(),
    title: z.string().optional(),
});
export const UpdateImageApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        imageId: ImageCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: UpdateImageBodySchema,
    response: ImageSchema.omit({ s3Key: true }).extend({ signedUrl: z.string().url() }),
};
export const UpdateImageRequestSchema = UpdateImageApiSchema.params
    .merge(UpdateImageApiSchema.body)
    .merge(UpdateImageApiSchema.headers);
